<script lang="ts">
  import {base} from '$app/paths';

  import GojiraCardElement from '$lib/components/gojiras/GojiraCardElement.svelte';
  import Modal from '$lib/components/styled/Modal.svelte';
  import {BaseCard, encodeFight, encodeFullGojira, GojiraCard} from '$lib/gojiras';
  import {currentGojira} from '$lib/state/gojiras';
  import {currentSettings} from '$lib/state/settings';
  import {stakeDeck} from '$lib/state/stake';

  let _chooseBaseCardForIndex: number | undefined;
  function chooseBaseCard(index: number) {
    _chooseBaseCardForIndex = index;
  }
  function selectBaseCard(cardType: number) {
    console.log(`selecting ${cardType}`);
    for (let i = 0; i < $stakeDeck.cardsPlayed.baseCards.length; i++) {
      if ($stakeDeck.cardsPlayed.baseCards[i] !== undefined && $stakeDeck.cardsPlayed.baseCards[i] === cardType) {
        $stakeDeck.cardsPlayed.baseCards[i] = undefined;
      }
    }
    $stakeDeck.cardsPlayed.baseCards[_chooseBaseCardForIndex] = cardType;
    _chooseBaseCardForIndex = undefined;
  }

  let _chooseGojiraCardForIndex: number | undefined;
  function chooseGojiraCard(index: number) {
    _chooseGojiraCardForIndex = index;
  }
  function selectGojiraCard(attributeIndex: number, cardIndex: number) {
    console.log(`selecting ${attributeIndex},${cardIndex}`);
    for (let i = 0; i < $stakeDeck.cardsPlayed.gojiraCards.length; i++) {
      if (
        $stakeDeck.cardsPlayed.gojiraCards[i] !== undefined &&
        $stakeDeck.cardsPlayed.gojiraCards[i].attributeIndex === attributeIndex
      ) {
        $stakeDeck.cardsPlayed.gojiraCards[i] = undefined;
      }
    }
    $stakeDeck.cardsPlayed.gojiraCards[_chooseGojiraCardForIndex] = {
      attributeIndex,
      cardIndex,
    };
    _chooseGojiraCardForIndex = undefined;
  }

  function sum(baseCard: BaseCard, gojiraCard: GojiraCard): GojiraCard {
    return {
      attack: baseCard.attack + gojiraCard.attack,
      defense: baseCard.defense + gojiraCard.defense,
      strength: baseCard.strength + gojiraCard.strength,
      protection: baseCard.protection + gojiraCard.protection,
    };
  }

  let fightURL: string | undefined;
  function fight() {
    const encoded = encodeFight({
      fullGojira: {gojira: $currentGojira, settings: $currentSettings},
      cardsPlayed: $stakeDeck.cardsPlayed,
    });

    fightURL = location.protocol + '//' + location.host + base + '/fight/' + `#${encoded}`;
  }

  function randomize() {
    const list = Array.from(Array($currentGojira.attributes.length)).map((v, i) => i);
    for (let i = 0; i < $stakeDeck.cardsPlayed.gojiraCards.length; i++) {
      const rndI = Math.floor(Math.random() * list.length);
      const item = list[rndI];
      list.splice(rndI, 1);
      $stakeDeck.cardsPlayed.gojiraCards[i] = {attributeIndex: item, cardIndex: 0};
    }

    const list2 = Array.from(Array($currentSettings.baseCardSets[0].length)).map((v, i) => i);
    for (let i = 0; i < $stakeDeck.cardsPlayed.baseCards.length; i++) {
      const rndI = Math.floor(Math.random() * list2.length);
      const item = list2[rndI];
      list2.splice(rndI, 1);
      $stakeDeck.cardsPlayed.baseCards[i] = item;
    }
  }

  $: fightReady =
    $stakeDeck.cardsPlayed.baseCards.filter((v) => v !== undefined).length == $stakeDeck.cardsPlayed.baseCards.length &&
    $stakeDeck.cardsPlayed.gojiraCards.filter((v) => v !== undefined).length ==
      $stakeDeck.cardsPlayed.gojiraCards.length;
</script>

<h1 class="font-black text-xl">Rules</h1>
<p>if (att > def) => loss = str - pro</p>

<button class="border-2 border-black p-2 m-2" on:click={randomize}>randomize</button>
<table>
  <thead />
  <tbody>
    <tr>
      <td class="w-32">Base Cards</td>
      {#each $stakeDeck.cardsPlayed.baseCards as baseCard, i}
        <td class="w-32">
          {#if baseCard === undefined}
            <GojiraCardElement on:click={() => chooseBaseCard(i)} />
          {:else}
            <GojiraCardElement
              card={$currentSettings.baseCardSets[$currentGojira.base][baseCard]}
              on:click={() => chooseBaseCard(i)}
            />
          {/if}
        </td>
      {/each}
    </tr>
    <tr>
      <td class="w-32">Gojira Cards</td>
      {#each $stakeDeck.cardsPlayed.gojiraCards as choice, i}
        <td class="w-32">
          {#if choice === undefined}
            <GojiraCardElement on:click={() => chooseGojiraCard(i)} />
          {:else}
            <GojiraCardElement
              cardType={$currentSettings.gojiraCardSets[choice.attributeIndex].type}
              card={$currentSettings.gojiraCardSets[choice.attributeIndex].set[
                $currentGojira.attributes[choice.attributeIndex]
              ][choice.cardIndex]}
              on:click={() => chooseGojiraCard(i)}
            />
          {/if}
        </td>
      {/each}
    </tr>
    <tr>
      <td class="w-32">TOTAL</td>
      {#each [0, 1, 2, 3, 4] as choice, i}
        <td class="w-32">
          {#if $stakeDeck.cardsPlayed.baseCards[choice] === undefined || $stakeDeck.cardsPlayed.gojiraCards[choice] === undefined}
            ...
          {:else}
            <GojiraCardElement
              card={sum(
                $currentSettings.baseCardSets[$currentGojira.base][$stakeDeck.cardsPlayed.baseCards[choice]],
                $currentSettings.gojiraCardSets[$stakeDeck.cardsPlayed.gojiraCards[choice].attributeIndex].set[
                  $currentGojira.attributes[$stakeDeck.cardsPlayed.gojiraCards[choice].attributeIndex]
                ][$stakeDeck.cardsPlayed.gojiraCards[choice].cardIndex]
              )}
            />
          {/if}
        </td>
      {/each}
    </tr>
  </tbody>
</table>

{#if fightReady}
  <button class="border-black border-2 p-2 m-2" on:click={fight}>FIGHT</button>
{/if}

{#if fightURL}
  <a href={fightURL}>{fightURL}</a>
{/if}

{#if _chooseBaseCardForIndex !== undefined}
  <Modal on:close={() => (_chooseBaseCardForIndex = undefined)}>
    {#each $currentSettings.baseCardSets[$currentGojira.base] as baseCardSet, cardType}
      <GojiraCardElement
        used={$stakeDeck.cardsPlayed.baseCards.find((v) => v !== undefined && v == cardType) !== undefined}
        card={$currentSettings.baseCardSets[$currentGojira.base][cardType]}
        on:click={() => selectBaseCard(cardType)}
      />
    {/each}
  </Modal>
{/if}

{#if _chooseGojiraCardForIndex !== undefined}
  <Modal on:close={() => (_chooseGojiraCardForIndex = undefined)}>
    {#each $currentGojira.attributes as attribute, attributeIndex}
      <!-- <GojiraCardElement used={$stakeDeck.cardsPlayed.gojiraCards.find((v) => v !== undefined && v.attributeIndex === attributeIndex) !== undefined} cardType={$currentSettings.gojiraCardSets[attributeIndex].type} card={$currentSettings.gojiraCardSets[attributeIndex].set[$currentGojira.attributes[attributeIndex]][0]} on:click={() => selectGojiraCard(attributeIndex, 0)} />   -->
      {#each $currentSettings.gojiraCardSets[attributeIndex].set[attribute] as card, cardIndex}
        <GojiraCardElement
          used={$stakeDeck.cardsPlayed.gojiraCards.find(
            (v) => v !== undefined && v.attributeIndex === attributeIndex
          ) !== undefined}
          cardType={$currentSettings.gojiraCardSets[attributeIndex].type}
          {card}
          on:click={() => selectGojiraCard(attributeIndex, cardIndex)}
        />
      {/each}
    {/each}
  </Modal>
{/if}
